/*
 * @Desc: 页面路由(使用小驼峰规则命名，如videoDetail、goodsList)
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-07-16 09:38:27
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
 */

/**
 * meta中 role       为角色权限，决定用户是否有权限访问该路由
 * keepAlive        为缓存选项，如果该路由需要缓存，值设为true
 * requiresAuth     验证登录权限
 * title            页面标题
 */

import nofound from '.././components/Nofound.vue';
import iframe from '.././components/Iframe.vue';

// user    role:0
import index from './../views/Index.vue'; // 首页
import SchoolProfile from './../views/SchoolProfile.vue'; // 学校概况
import SchoolProfileDetail from './../views/SchoolProfileDetail.vue'; // 学校概况
import SchoolNews from './../views/SchoolNews.vue'; // 学校新闻
import NewsDetail from './../views/NewsDetail.vue'; // 学校新闻 详情
import Teachers from './../views/Teachers.vue'; // 师资队伍 详情
import Apply from './../views/Apply.vue'; // 报名信息
import FreshApply from './../views/FreshApply.vue'; // 报名信息
import contact from './../views/contact.vue'; // 意见反馈
import Search from './../views/Search.vue'; // 全局搜索
import Link from './../views/Link.vue'; // 友情链接
import PayType from './../views/PayType.vue'; // 支付中心

export default [
    // 内容的模板
    {
        path: '/',
        component: iframe,
        meta: {
            requiresAuth: false
        },
        children: [
            // 首页
            {
                path: '/',
                name: 'home',
                component: index,
                meta: {
                    requiresAuth: false,
                    title: '首页',
                    role: 0,
                    keepAlive: false
                }
            },
            // 学校概况
            {
                path: '/SchoolProfile',
                name: 'SchoolProfile',
                component: SchoolProfile,
                meta: {
                    requiresAuth: false,
                    title: '学校概况',
                    role: 0,
                    keepAlive: false
                }
            },
            // 学校概况 详情
            {
                path: '/SchoolProfileDetail',
                name: 'SchoolProfileDetail',
                component: SchoolProfileDetail,
                meta: {
                    requiresAuth: false,
                    title: '学校概况',
                    role: 0,
                    keepAlive: false
                }
            },
            // 学校新闻
            {
                path: '/SchoolNews',
                name: 'SchoolNews',
                component: SchoolNews,
                meta: {
                    requiresAuth: false,
                    title: '学校新闻',
                    role: 0,
                    keepAlive: false
                }
            },
            // 学校新闻 详情
            {
                path: '/NewsDetail',
                name: 'NewsDetail',
                component: NewsDetail,
                meta: {
                    requiresAuth: false,
                    title: '学校新闻',
                    role: 0,
                    keepAlive: false
                }
            },
            // 师资队伍
            {
                path: '/Teachers',
                name: 'Teachers',
                component: Teachers,
                meta: {
                    requiresAuth: false,
                    title: '师资队伍',
                    role: 0,
                    keepAlive: false
                }
            },
            // 招生招聘
            {
                path: '/Apply',
                name: 'Apply',
                component: Apply,
                meta: {
                    requiresAuth: false,
                    title: '招生招聘',
                    role: 0,
                    keepAlive: false
                }
            },
            // 应届生招生招聘
            {
                path: '/FreshApply',
                name: 'FreshApply',
                component: FreshApply,
                meta: {
                    requiresAuth: false,
                    title: '应届生招生招聘',
                    role: 0,
                    keepAlive: false
                }
            },
            // 反馈
            {
                path: '/contact',
                name: 'contact',
                component: contact,
                meta: {
                    requiresAuth: false,
                    title: '意见反馈',
                    role: 0,
                    keepAlive: false
                }
            },
            // 全局搜索
            {
                path: '/Search',
                name: 'Search',
                component: Search,
                meta: {
                    requiresAuth: false,
                    title: '全局搜索',
                    role: 0,
                    keepAlive: false
                }
            },
            // 友情链接
            {
                path: '/Link',
                name: 'Link',
                component: Link,
                meta: {
                    requiresAuth: false,
                    title: '友情链接',
                    role: 0,
                    keepAlive: false
                }
            },
            // 支付中心
            {
                path: '/PayType',
                name: 'PayType',
                component: PayType,
                meta: {
                    requiresAuth: false,
                    title: '支付中心',
                    role: 0,
                    keepAlive: false
                }
            },
            // 其它404
            {
                path: '*',
                name: 'noaccess',
                component: nofound,
                meta: {
                    requiresAuth: true,
                    pageTitle: '404'
                }
            }
        ]
    }
];
